import React, { useState, useEffect, useRef } from "react"
import { navigate } from "gatsby"
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext'
import { useCart } from '~/contexts/CartContext'
import { imgSize, deShopId, reShopId, jnstyls } from '~/utils/helpers'
import useCartHook from '~/hooks/useCartHook'

import IconClose from '~/components/icons/close'
import CartUpsell from '~/components/cart/upsell'
import TestCartUpsell from '~/components/cart/test-upsell'

import { aria_btn, cta_link } from "~/styles/app.module.scss"
import * as styles from "~/styles/panels/cart.module.scss"

const CartItem = ({ line, index, cartLines, setBlockKey, handleClose }) => {
  const { 
    cartApi, cart, setCartOpen, cartClose, setCartClose, cartRecs, showGiftCard, setShowGiftCard, setGiftInfo
  } = useCart()
  const { changeLine } = cartApi

  const [recProds, setRecProds] = useState(false)
  const [showRecs, setShowRecs] = useState(index === 0)

  const item = line.merchandise
  const var_id = item.id
  const product = item.product
  const title = product.mPl ? product.mPl.value : product.title
  const color = product.mColor ? product.mColor.value : false
  const pickup = (line.attributes && line.attributes.length && line.attributes.find(x => x.key === 'Pickup Location')) || false
  const is_gift = product.handle === 'gift'
  const is_vintage = product.is_vintage
  const has_hem = (line.attributes && line.attributes.length && line.attributes.find(x => x.key === 'Hem')) || false
  let gift_info = false


  if (is_gift && product.handle === 'gift') {
    gift_info = {
      name: line.attributes.find(x => x.key === 'Recipient Name') || false,
      email: line.attributes.find(x => x.key === 'Recipient Email') || false,
      date: line.attributes.find(x => x.key === 'Delivery Date') || false,
      message: line.attributes.find(x => x.key === 'Message') || false,
    }
  }


  const handleLink = (url) => {
    setCartOpen(false)
    navigate(url)
    handleClose()
  }

  const handleGiftEdit = (line) => {
    setGiftInfo({line: line, edit: true})
    setShowGiftCard(true)
    setBlockKey(true)
  }

  const price_format = (price) => {
    const fprice = price.includes('.') && price.includes('.0') ? parseFloat(price).toFixed(0) : parseFloat(price).toFixed(2)
    return `$${fprice}`
  }

  const checkPreorder = (line) => {
    if (line?.attributes?.length < 1) return false
    const item = line.attributes.find(x => x.key.toLowerCase().includes('pre-order'))
    return item?.value || false
  }
  const is_preorder = checkPreorder(line)

  const recsOutfits = () => {

    const recs_arr = cartRecs || []
    let rec_prods = recs_arr.find( x => reShopId(x.shop_id) === product.id) || []
    if (rec_prods?.length > 0) {
      rec_prods = JSON.parse(JSON.stringify(rec_prods))
      const recs_arr = (rec_prods && rec_prods.hasOwnProperty('recs')) ? rec_prods.recs : []
      rec_prods.recs = recs_arr.sort(() => 0.5 - Math.random())
    }

    let outfits = []
    // if ( (last_item && !last_item.node?.merchandise?.sku?.includes('.VIN')) && (rec_prods && rec_prods?.outfits?.length > 0) ) {
    //   const all_shop_ids = cart.lines?.edges?.length > 0 ? cart.lines.edges.map(x => deShopId(x.node.merchandise.product.id)) : []
    //   if (rec_prods.outfits && !all_shop_ids.includes(rec_prods.outfits[0].shop_id)) {
    //     outfits = rec_prods.outfits.filter(x => !!x && !all_shop_ids.includes(x.shop_id))
    //     const lastprod = last_item.node.merchandise.product
    //     const reftitle = lastprod.mPl ? lastprod.mPl.value : lastprod.title
    //     outfits.forEach(x => x['reftitle'] = reftitle)
    //   }
    // }
    // outfits = outfits.map(otf => { 
    //   const standcol = otf.product_line?.colors?.standard?.find(x => x.handle === otf.handle)?.name
    //   const vwashcol = otf.product_line?.colors?.venice_wash?.find(x => x.handle === otf.handle)?.name
    //   const color_name = standcol || vwashcol || ''
    //   return {...otf, pl_name: otf.product_line?.name, color: color_name} 
    // })
    
    if (rec_prods) {
      rec_prods.outfits = outfits
    }
    setRecProds(rec_prods)
  }

  const testSpace = (typeof document !== 'undefined') && sessionStorage.getItem('ncart')

  useEffect(() => {
    recsOutfits()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div 
        className={styles.item}
      >
        <button
          type="button"
          className={[aria_btn, styles.image].join(' ')}
          onClick={(e)=>{handleLink(`/products/${product.handle}`)}}
        >
          <img 
            className={styles.img} 
            src={imgSize(item.image.url,300)}
            alt={`Buck Mason ${product.title}`} 
            height="600" 
            width="450" 
          />
        </button>

        <div className={styles.details}>
          <div className={styles.title_price}>
            <button 
              type="button"
              className={[aria_btn, styles.title].join(' ')} 
              onClick={(e)=>{handleLink(`/products/${product.handle}`)}}
            >
              {title}
            </button>
            {item.priceV2 && (
              <div className={styles.price}>
                {price_format(item.priceV2.amount)}
              </div>
            )}
          </div>

          {(color && !is_vintage) && (
            <div className={styles.color}>{color}</div>
          )}

          {(!product.single && item.title) && (
            <div className={styles.size}>{item.title}</div>
          )}

          {has_hem && (
            <div className={styles.hem}>
              <div>
                <strong>
                  {has_hem.key}:
                </strong>
              </div>
              <div>
                {has_hem.value}" Inseam
              </div>
            </div>
          )}

          {product.handle === 'gift' && (
            <div className={styles.gift}>
              <div className={styles.gift_info}>
                {gift_info.name && (
                  <>
                    <div>
                      <strong>
                        Recipient Name:
                      </strong>
                    </div>
                    <div>
                      {gift_info.name.value}
                    </div>
                  </>
                )}
                {gift_info.email && (
                  <>
                    <div>
                      <strong>
                        TO:
                      </strong>
                    </div>
                    <div>
                      ({gift_info.email.value})
                    </div>
                  </>
                )}
                {gift_info.date && (
                  <>
                    <div>
                      <strong>
                        Delivery Date:
                      </strong>
                    </div>
                    <div>
                      {gift_info.date.value}
                    </div>
                  </>
                )}
                {gift_info.message && (
                  <>
                    <div>
                      <strong>
                        Message:
                      </strong>
                    </div>
                    <div>
                      {gift_info.message.value}
                    </div>
                  </>
                )}
              </div>
              <div className={styles.gift_edit}>
                <button 
                  type={'button'}
                  className={[aria_btn, cta_link].join(' ')}
                  aria-label="Edit recipient details - opens a dialog" 
                  onClick={(e)=>{handleGiftEdit(line)}}
                >
                  Edit
                </button>
              </div>
            </div>
          )}

          <div className={styles.change}>
            <div className={styles.qty_edit}>
              {(!is_vintage && product.handle !== 'gift') && (
                <button 
                  type={'button'}
                  className={[aria_btn, styles.qty_btn].join(' ')}
                  aria-label="Decrease quantity"
                  onClick={ (e)=>{ changeLine(line, false, -1) } }
                ></button>
              )}
              <div 
                aria-live="polite" 
                aria-atomic="true" 
                aria-relevant="text" 
              >
                {line.quantity}
              </div>
              {(!is_vintage && product.handle !== 'gift') && (
                <button 
                  type={'button'}
                  className={[aria_btn, styles.qty_btn, styles.plus].join(' ')}
                  onClick={ (e)=>{ changeLine(line, false, 1) } }
                  aria-label={'Increase quantity'}
                ></button>
              )}
            </div>
            <button 
              type={'button'}
              className={[aria_btn, styles.remove].join(' ')}
              data-minicart-remove=''
              aria-label={`Remove ${product.title} from cart`}
              onClick={ (e)=>{ changeLine(line, false, 0) } }
            >
              <IconClose icon_classes={styles.icon_remove} />
            </button>
          </div>

          {(product.handle !== 'gift' && !is_preorder) && (
            <div className={styles.delivery}>
              {pickup ? `Pick up At ${pickup.value}`: 'Ship to Address'}
            </div>
          )}

          {(product.handle !== 'gift' && is_preorder) && (
            <div className={styles.final}>
              Pre-order expected ship date: {is_preorder}.
            </div>
          )}

          {(!is_preorder && (product.tags.includes('finalsale') || has_hem)) && (
            <div className={styles.final}>
              Final sale: This item is not returnable.
            </div>
          )}
        </div>
      </div>

      {(testSpace && recProds) && (
        <div className={jnstyls([styles.item_recs, showRecs ? '' : styles.noshow])}>
          {(showRecs)? (
            <TestCartUpsell recProds={recProds} itemUpsell={true} />
          ): (
            <button 
              type={'button'}
              className={jnstyls([aria_btn, cta_link, styles.recshow_btn])}
              aria-label="Show recommendations" 
              onClick={(e)=>{setShowRecs(true)}}
            >
              Show {recProds.recs.length} Recommendation{recProds.recs.length > 1 ? 's' : ''}
            </button>
          )}
        </div>
      )}
      
    </>
  )
}

export default CartItem
